import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { setPortal } from 'modules/portal';
import {
  converParameters,
  makeRowColumn,
  getHeadObj,
  getHost,
} from 'lib/commonLib';
import { toggleCollect } from 'lib/api/keywordcenter';
import { keywordStatusStatistics } from 'lib/api/keywordcenter';
import { showSuccessSnackbar } from 'modules/snackbar';

import MbSwitch from 'components/atoms/MbSwitch';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

const Statistics = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [reFetch, setRefetch] = useState(false);
  const { portal } = useSelector(({ portal }) => ({ portal: portal }));
  let initParams = { sort: 'asc', order: 'ADVER_ID', contact: 'all' };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  const customized = {
    KWRD_GRP_NO: { merged: true },
    CORP_NAME: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'CORP_NAME');
        const showWindowUrl = converParameters({
          url: getHost() + '/v2/popup/manage_report_media_day_mc_mcode.php',
          gb: 'TOT',
          mcode: rowObj['ADVER_ID'],
          sendType: 'keyword',
        });
        return (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['CORP_NAME'],
              bodyItem1.type,
              bodyItem1.format
            )}
            icon="faExternalLink"
            toolTipTitle={t('해당 광고주의 통계')}
            onClick={(e) => handlePortalUrl(showWindowUrl)}
          />
        );
      },
      headStyle: { width: 300 },
      bodyStyle: { textAlign: 'left' },
    },
    TOT_KEYWORD_CNT: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'TOT_KEYWORD_CNT');
        const showWindowUrl = converParameters({
          url: getHost() + '/v2/popup/pop_keyword_report_adver.php',
          adverId: rowObj['ADVER_ID'],
        });
        return (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['TOT_KEYWORD_CNT'],
              bodyItem1.type,
              bodyItem1.format
            )}
            icon="faExternalLink"
            toolTipTitle={t('해당 광고주의 통계')}
            onClick={(e) => handlePortalUrl(showWindowUrl)}
          />
        );
      },
    },
    COLLECT_YN: {
      makeBody: (rowObj) => {
        return (
          rowObj['COLLECT_YN'] !== null && (
            <MbSwitch
              onChange={() => handleToggle(rowObj)}
              value="on"
              hasLabel
              checked={rowObj['COLLECT_YN'] === 'Y'}
            />
          )
        );
      },
      headStyle: { width: 150 },
    },
  };

  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
    }
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  const handleToggle = (rowObj) => {
    const { KWRD_GRP_NO, ADVER_ID } = rowObj;
    toggleCollect({ keywordGrpNo: KWRD_GRP_NO, adverId: ADVER_ID })
      .then((response) => {
        const { message } = response.data;
        handleClickSnackbar({ message: message, option: { type: 'success' } });
        setRefetch(true);
      })
      .catch((error) =>
        handleClickSnackbar({ message: error, option: { type: 'error' } })
      )
      .finally(() => {
        setRefetch(false);
      });
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useDate={false}
          useExternalFilter={false}
          useDisplayFilter={false}
          usePltfomTpCodeFilter={false}
          useManagerFilter={true}
        />
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={keywordStatusStatistics}
        customized={customized}
        useTotal={false}
        reFetch={reFetch}
      />
    </>
  );
};

export default withRouter(Statistics);
